import Features from '../../components/features/Features'
import Navbar from '../../components/navbar/Navbar'
import Footer from '../../components/footer/Footer'
import Outlined from '../../components/div/Outlined'
import {useEffect, useState} from 'react'
import {useLocation} from 'react-router'
import { Link } from 'react-router-dom'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import './room.css'
import { addProduct } from '../../components/redux/cartSlice'
import { axiosInstance } from '../../config'


function Room() {
       const [house, setHouse] = useState([]);
       const [name, setName] = useState('');
       const [id, setId] = useState('');
       const[phone, setPhone] = useState('');
       const [date, setDate] = useState('');
       const dispatch = useDispatch();

    useEffect(() => {
    const getHouse = async() => {
    try {
        const res =  await axiosInstance.get('/api/houses');
    setHouse(res.data)
    } catch (err) {
      console.log(err)  
    }
    }
    getHouse();
    },[]);

    const location = useLocation();
    console.log(location);
    const path = location.pathname.split('/')[2];
    const room = house.find((p) => p._id.toString() === path);
    const img = room?.img
    const cost = room?.cost
    console.log(cost);

    const handleClick = () =>{
      dispatch(addProduct({ img, cost, name, id, phone, date}));
    }

    return (
        <>
        <div className='room'>
            <Navbar/>
            <h2 className='roomNum'>{`${room?.title}. Welcome`}</h2>
            <div className="roomWrapper">
                <img src={room?.img} alt=''/>
                <div className='roomInfo'>
                  <div className='roomLeft'>
                      <h2>Room Features</h2>
                      <div className='featuresWrapper'>
                         <Features room={room}/>
                      </div>
                      <p className='availability'><b>Room availability:</b>Available</p>
                  </div>
                  <div className='roomRight'>
                   <h2>Rent Room Now</h2>
                   <div className='rent--form'>
                       <label>Name</label>
                       <input  type='text'
                        placeholder='eg. Joshua Kioko' 
                        onChange={(e) => setName(e.target.value)} />

                        <label>National ID</label>
                       <input type='number' 
                       placeholder='eg. 28843682' 
                       onChange={(e) => setId(e.target.value)}/>

                        <label>Phone NO</label>
                       <input type='text'
                        placeholder='eg. 0745231894' 
                        onChange={(e) => setPhone(e.target.value)}/>

                        <label>Date of vaccating</label>
                       <input type='text' 
                       placeholder='eg. 28th Jan 2022'
                        onChange={(e) => setDate(e.target.value)}/>
                     <Link to='/pay' className='link'>
                     <button className='rentBtn' onClick={handleClick}>Proceed with Renting</button>
                     </Link>
                   </div>
                  </div>
                </div>
                <div className='room--desc'>
                  <h2>Room Description and Directives</h2>
              <Outlined/>
              {room?.properties.map((property) => (
               <p><i class="fas fa-info-circle"></i> {property}</p>
              ))}
                </div>
            </div>
             <Footer/>
        </div>
       
        </>
    )
}

export default Room
